import React from 'react'

function LoadingSpinner({ compact = false }) {
  return (
    <div className={`loading-spinner-container${compact ? ' loading-spinner-container--compact' : ''}`} role="status" aria-live="polite">
      <div className="loading-spinner" aria-hidden="true"></div>
      <span className="visually-hidden">Loading</span>
    </div>
  )
}

export default LoadingSpinner
